import { Info, InfoDark, isPwaMode, noop, useAppTheme } from '@capsicum/common';
import { GenericDrawer, Text } from '@capsicum/common-web';
import { type FanTokenOfferingDisclaimerProps } from '@capsicum/features/fan-token-offering/shared';
import { useGenericAgreement } from '@capsicum/features/regulations/shared';
import styled from 'styled-components';

export const FanTokenOfferingDisclaimer = ({
	closeModal,
	onAgree,
	onDisagree,
	requirement,
	testID
}: FanTokenOfferingDisclaimerProps) => {
	const { mode } = useAppTheme();

	const { acceptAgreement, agreeButtonText, cancelAgreement, disagreeButtonText, subtitle, title } =
		useGenericAgreement(requirement);

	return (
		<GenericDrawer
			buttonText={agreeButtonText}
			image={mode === 'dark' ? InfoDark : Info}
			isButtonFullWidth={!!isPwaMode()}
			isButtonOnRow={false}
			secondaryActionButtonText={disagreeButtonText}
			testID={`${testID}-disclaimer`}
			title={title}
			onButtonPress={() => {
				acceptAgreement({ close: closeModal, delay: 100, showConfirmModal: noop });
				onAgree?.();
			}}
			onSecondaryActionOnButtonPress={() => {
				cancelAgreement({ close: closeModal, delay: 100, showDeclineModal: noop });
				onDisagree?.();
			}}
		>
			<S.Description variant="text3">{subtitle}</S.Description>
		</GenericDrawer>
	);
};

namespace S {
	export const Description = styled(Text)`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		text-align: center;
	`;
}
